import { IWidgetConfigItem } from '@sitegen/common/types';
import { WIDGET_CONFIG, WIDGET_NAME } from '@sitegen/common/constants';

export const WIDGET_ANALYTICS_INFO = {
    siteSection: '',
    siteName: 'ULC Redeem',
    homePage: {
        name: 'main',
        subSection: 'flow'
    },
    emailVerificationPage: {
        name: 'validate your email',
        subSection: 'flow'
    },
    platformSelectionPage: {
        name: 'platform selection',
        subSection: 'flow'
    },
    redeemSuccessfulPage: {
        name: 'redeem successful',
        subSection: 'flow'
    },
    loginPage: {
        name: 'login',
        subSection: 'flow'
    },
    additionalInfoPage: {
        name: 'additional information',
        subSection: 'flow'
    },
    codeRedeemedError: {
        name: 'code already used',
        subSection: 'error'
    },
    notEligibleError: {
        name: 'not eligible',
        subSection: 'error'
    },
    genericError: {
        name: 'generic error',
        subSection: 'error'
    },
    invalidCodeError: {
        name: 'invalid code',
        subSection: 'error'
    },
    userRedeemedError: {
        name: 'user already claimed the item',
        subSection: 'error'
    }
};

export class Analytics {
    public static Constants: typeof WIDGET_ANALYTICS_INFO = WIDGET_ANALYTICS_INFO;

    /** Add extra widget-specific values */
    public static configure(widget: WIDGET_NAME): void {
        const config: IWidgetConfigItem = WIDGET_CONFIG[widget];
        Analytics.Constants.siteSection = config.widgetFlowType;
    }
}
